import { DA_DeliveryPoint } from "@danishagro/shared/src/hooks/api/useDeliveryPointsApi.hook";

type DeliveryPointOption = DA_DeliveryPoint | { id: string; name: string; description?: string };

/**
 * Hook that provides standardized handlers for delivery point select components.
 * Returns getLabel, getValue, and getExtra functions to be used with DA_Select.
 */
export const useDeliveryPointSelectHandlers = () => {
    return {
        getLabel: ({ name }: DeliveryPointOption) => name,
        getValue: ({ id }: DeliveryPointOption) => id,
        getExtra: (deliveryPoint: DeliveryPointOption) => {
            const description = deliveryPoint.description;
            const capacity = "capacity" in deliveryPoint ? deliveryPoint.capacity : undefined;
            const capacityDescription =
                "capacityDescription" in deliveryPoint
                    ? deliveryPoint.capacityDescription
                    : undefined;

            if (!description && !capacity) return undefined;

            // If capacity is present, include it with description
            if (capacityDescription && description) {
                return `${description} - ${capacityDescription}`;
            }
            if (capacityDescription) {
                return capacityDescription;
            }
            return description;
        },
    };
};
